import React, { useEffect, useState } from "react";
import logo from "../../Vectors/logo.png";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "../../i18n/LanguageContext";
import LanguageSwitcher from "../../components/LanguageSwitcher";
import "./style.css";

const navItems = [
    { to: "/About", key: "nav.about" },
    { to: "/Volunteers", key: "nav.volunteers" },
    { to: "/Organizations", key: "nav.organizations" },
    { to: "/Events", key: "nav.events" },
    { to: "/BecomePartner", key: "nav.becomePartner" },
];

export default function Header() {
    const { t } = useTranslation();
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    // Lock body scroll while the mobile menu is open.
    useEffect(() => {
        document.body.style.overflow = menuOpen ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [menuOpen]);

    const closeMenu = () => setMenuOpen(false);

    return (
        <>
            <header className={`header ${scrolled ? "header--scrolled" : ""}`}>
            <div className="header__inner">
                <div className="logo">
                    <Link to="/" onClick={closeMenu} aria-label="CtrlEvents — գլխավոր">
                        <img src={logo} alt="CtrlEvents" />
                    </Link>
                </div>

                <nav className="nav-btns" aria-label="Հիմնական">
                    {navItems.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            className={({ isActive }) =>
                                isActive ? "active" : ""
                            }
                        >
                            {t(item.key)}
                        </NavLink>
                    ))}
                    <a href="/#app" className="login">
                        {t("nav.download")}
                    </a>
                    <LanguageSwitcher />
                </nav>

                <button
                    type="button"
                    className={`hamburger ${menuOpen ? "is-open" : ""}`}
                    aria-label={menuOpen ? "Փակել մենյուն" : "Բացել մենյուն"}
                    aria-expanded={menuOpen}
                    onClick={() => setMenuOpen((v) => !v)}
                >
                    <span />
                    <span />
                    <span />
                </button>
            </div>
            </header>

            {/* Mobile menu — rendered OUTSIDE <header> so its position:fixed is
                relative to the viewport, not the header's backdrop-filter box. */}
            <div
                className={`mobile-overlay ${menuOpen ? "is-open" : ""}`}
                onClick={closeMenu}
                aria-hidden="true"
            />
            <nav
                className={`mobile-menu ${menuOpen ? "is-open" : ""}`}
                aria-label="Շարժական մենյու"
            >
                {navItems.map((item) => (
                    <NavLink
                        key={item.to}
                        to={item.to}
                        onClick={closeMenu}
                        className={({ isActive }) => (isActive ? "active" : "")}
                    >
                        {t(item.key)}
                    </NavLink>
                ))}
                <a href="/#app" className="login" onClick={closeMenu}>
                    {t("nav.download")}
                </a>
                <LanguageSwitcher className="is-block" />
            </nav>
        </>
    );
}
